import request from '@/utils/request'

/**
 * 工勤人员分析-获取年龄分布(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserBigdataAgeGet(data) {
  return request({
    type: 'biz',
    url: 'deptuser/bigdata/age/get',
    method: 'post',
    data
  })
}

/**
 * 工勤人员分析-获取职务分布(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserBigdataDutyGet(data) {
  return request({
    type: 'biz',
    url: 'deptuser/bigdata/duty/get',
    method: 'post',
    data
  })
}

/**
 * 工勤人员分析-获取学历分布(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserBigdataEducationGet(data) {
  return request({
    type: 'biz',
    url: 'deptuser/bigdata/education/get',
    method: 'post',
    data
  })
}

/**
 * 工勤人员分析-人员明细列表全部导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserBigdataListExport(data) {
  return request({
    type: 'biz',
    url: 'deptuser/bigdata/list/export',
    method: 'post',
    data
  })
}

/**
 * 工勤人员分析-人员明细列表(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserBigdataListGet(data) {
  return request({
    type: 'biz',
    url: 'deptuser/bigdata/list/get',
    method: 'post',
    data
  })
}

/**
 * 工勤人员分析-人员明细列表部分导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserBigdataListOptionExport(data) {
  return request({
    type: 'biz',
    url: 'deptuser/bigdata/list/option/export',
    method: 'post',
    data
  })
}

/**
 * 工勤人员分析-获取性别分析(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserBigdataSexGet(data) {
  return request({
    type: 'biz',
    url: 'deptuser/bigdata/sex/get',
    method: 'post',
    data
  })
}

/**
 * 食堂人员管理-删除(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserDelete(data) {
  return request({
    type: 'biz',
    url: 'deptuser/delete',
    method: 'post',
    data
  })
}

/**
 * 食堂人员管理-新增(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserInsert(data) {
  return request({
    type: 'biz',
    url: 'deptuser/insert',
    method: 'post',
    data
  })
}

/**
 * 食堂人员管理-人员列表（查询条件：食堂、承包商）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptuserListGet(data) {
  return request({
    type: 'biz',
    url: 'deptuser/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DepartmentUser.js